import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_87621aa9-388b-4a4a-b140-4ad09ad180a4/artifacts/4hsu6g13_Agilitie_logo_white-disc.svg";

const LinkedInIcon = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="20" 
    height="20" 
    viewBox="0 0 24 24" 
    fill="currentColor"
    className="hover:text-[#d4782c] transition-colors duration-200"
  >
    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
  </svg>
);

export const Footer = () => {
  return (
    <footer className="bg-[#2c3038]" data-testid="main-footer">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Tagline */}
          <div className="lg:col-span-1">
            <Link to="/" data-testid="footer-logo-link" className="block">
              <img 
                src={LOGO_URL} 
                alt="Agilitie" 
                style={{ height: '80px', width: 'auto', display: 'block' }}
                data-testid="footer-logo"
              />
            </Link>
            <p 
              className="text-[#c0bdb7] text-sm leading-relaxed"
              style={{ marginTop: '13px', maxWidth: '280px' }}
            >
              A boutique organisational transformation advisory based in Melbourne, Australia.
            </p>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="text-[#d4782c] font-dm-sans font-semibold text-sm uppercase tracking-wider mb-6">
              Services
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/services#goldilocks" 
                  className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                  data-testid="footer-link-goldilocks"
                >
                  Goldilocks Zone Advisory
                </Link>
              </li>
              <li>
                <Link 
                  to="/services#operating-model" 
                  className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                  data-testid="footer-link-operating-model"
                >
                  Operating Model Design
                </Link>
              </li>
              <li>
                <Link 
                  to="/services#transformation" 
                  className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                  data-testid="footer-link-transformation"
                >
                  Transformation Assurance
                </Link>
              </li>
              <li>
                <Link 
                  to="/services#delivery" 
                  className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                  data-testid="footer-link-delivery"
                >
                  Delivery System Optimisation
                </Link>
              </li>
              <li>
                <Link 
                  to="/services#ai-readiness" 
                  className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                  data-testid="footer-link-ai-readiness"
                >
                  AI Readiness & Adoption
                </Link>
              </li>
            </ul>
          </div>

          {/* Explore Links */}
          <div>
            <h4 className="text-[#d4782c] font-dm-sans font-semibold text-sm uppercase tracking-wider mb-6">
              Explore
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/the-goldilocks-zone" 
                  className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                  data-testid="footer-link-goldilocks-zone"
                >
                  The Goldilocks Zone
                </Link>
              </li>
              <li>
                <Link 
                  to="/media-speaking" 
                  className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                  data-testid="footer-link-media-speaking"
                >
                  Media & Speaking
                </Link>
              </li>
              <li>
                <Link 
                  to="/people" 
                  className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                  data-testid="footer-link-people"
                >
                  Our People
                </Link>
              </li>
              <li>
                <Link 
                  to="/insights" 
                  className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                  data-testid="footer-link-insights"
                >
                  Insights
                </Link>
              </li>
              <li>
                <Link 
                  to="/giving-back" 
                  className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                  data-testid="footer-link-giving-back"
                >
                  #GivingBack
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#d4782c] font-dm-sans font-semibold text-sm uppercase tracking-wider mb-6">
              Contact
            </h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="mailto:contact@agilitie.com.au" 
                  className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                  data-testid="footer-email"
                >
                  contact@agilitie.com.au
                </a>
              </li>
              <li>
                <a 
                  href="tel:1300489850" 
                  className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                  data-testid="footer-phone"
                >
                  1300 489 850
                </a>
              </li>
              <li>
                <a 
                  href="https://www.linkedin.com/company/agilitie/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#c0bdb7] inline-flex items-center gap-2 hover:text-white transition-colors duration-200"
                  data-testid="footer-linkedin"
                >
                  <LinkedInIcon />
                  <span className="text-sm">LinkedIn</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#3d424a]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-[#c0bdb7] text-sm">
              © 2026 Agilitie. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link 
                to="/privacy" 
                className="text-[#c0bdb7] text-sm hover:text-white transition-colors duration-200"
                data-testid="footer-privacy"
              >
                Privacy Policy
              </Link>
              <a 
                href="https://www.linkedin.com/company/agilitie/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#c0bdb7] hover:text-[#d4782c] transition-colors duration-200"
                data-testid="footer-linkedin-icon"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
